import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useCurrentUser } from "../slices/auth/hooks";
import { DASHBOARD_USER_ROLES } from "../constants";
// icons
import adminIcon from "../assets/images/iconsRoles/GroupsIcons/adminIcon.svg";
// Inactive icons
import employeesIcon from "../assets/images/iconsRoles/GroupsIcons/employeesIcon.svg";
import brokerIcon from "../assets/images/iconsRoles/GroupsIcons/brokerIcon.svg";
import gaIcon from "../assets/images/iconsRoles/GroupsIcons/gaIcon.svg";
import individualIcon from "../assets/images/iconsRoles/indIcon.svg";
import commissionsIcon from "../assets/images/iconsRoles/GroupsIcons/payCommissions.svg";
import employerGroupIcon from "../assets/images/iconsRoles/GroupsIcons/employersIcon.svg";
import nationalIcon from "../assets/images/iconsRoles/GroupsIcons/nationalIcon.svg";
import profileIcon from "../assets/images/iconsRoles/GroupsIcons/profileIcon.svg";
import groupIcon from "../assets/images/iconsRoles/groupsIcon.svg";
import invoicesIcon from "../assets/images/iconsRoles/invoicesIcon.svg";

// ActiveIcons
import employeesIconActive from "../assets/images/iconsRoles/employeesIcon.svg";
import brokerIconActive from "../assets/images/iconsRoles/brokerIcon.svg";
import gaIconActive from "../assets/images/iconsRoles/GaIcon.svg";
import individualIconActive from "../assets/images/iconsRoles/IndividualsIcon.svg";
import commissionsIconActive from "../assets/images/iconsRoles/payCommissionsIcon.svg";
import employerGroupIconActive from "../assets/images/iconsRoles/employerGroupIcon.svg";
import nationalIconActive from "../assets/images/iconsRoles/nationalIcon.svg";
import profileIconActive from "../assets/images/iconsRoles/profileIcon.svg";
import groupIconActive from "../assets/images/iconsRoles/groupsIcon.svg";
import invoicesIconActive from "../assets/images/iconsRoles/invoicesIcon.svg";
import adminIconActive from "../assets/images/iconsRoles/adminIcon.svg";

const Navdata = () => {
  const navigate = useNavigate();
  const currentUser = useCurrentUser();
  const globalTheme = useSelector(state => state.Theme);
  const isWhitelabel = globalTheme?.whitelabelActive;

  const { role } = currentUser;

  const [currentState, setCurrentState] = useState("");
  const [isEmployees, setIsEmployees] = useState(false);
  const [isProfile, setIsProfile] = useState(false);
  const [isEmployerGroup, setIsEmployerGroup] = useState(false);
  const [isBrokerEmployees, setIsBrokerEmployees] = useState(false);
  const [isIndividualBooks, setIsIndividualBooks] = useState(false);
  const [isGaBroker, setIsGaBroker] = useState(false);
  const [isadmin, setIsadmin] = useState(false);
  const [iscurrentState, setIscurrentState] = useState("");
  const [isGroups, setIsGroups] = useState(false);

  const [isGroupsAdmin, setIsGroupsAdmin] = useState(false);

  useEffect(() => {
    document.body?.classList.remove("twocolumn-panel");

    setIsProfile(false);
    setIsEmployees(false);
    setIsEmployerGroup(false);
    setIsBrokerEmployees(false);
    setIsGaBroker(false);
    setIsadmin(false);
    setIsIndividualBooks(false);

    switch (iscurrentState) {
      case "adminGa":
        setIsadmin(true);
        break;

      case "individualBooks":
        setIsIndividualBooks(true);
        break;
      case "gaBrokers":
        setIsGaBroker(true);
        break;
      case "brokerEmployerGroup":
        setIsEmployerGroup(true);
        break;
      case "brokerEmployees":
        setIsBrokerEmployees(true);
        break;
      case "profile":
        setIsProfile(true);
        break;
      case "employees":
        setIsEmployees(true);
        break;

      default:
        setIsProfile(true);
        break;
    }
  }, [navigate, iscurrentState]);

  const handleItemClick = (link) => {
    setCurrentState(link);
    navigate(link);
  };

  const getSubItemsAdmin = () => {
    return [
      {
        id: "admin-dashboard",
        label: "Admin Dashboard",
        icon: {
          active: adminIconActive,
          inactive: adminIcon,
        },
        link: "/dashboard-admin",
        path: "/dashboard-admin",
        click: () =>
          handleItemClick({ id: "admin-dashboard", link: "/dashboard-admin" }),
      },
      {
        id: "member-management",
        label: "Member Management",
        icon: {
          active: adminIconActive,
          inactive: adminIcon,
        },
        link: "/member-management",
        onclick: () => handleItemClick({ id: "member-management", link: "/member-management" }),
      },
      {
        id: "commission-management",
        label: "Commission Management",
        icon: {
          active: commissionsIconActive,
          inactive: commissionsIcon,
        },
        link: "/commission-management",
        onclick: () => handleItemClick({ id: "commission-management", link: "/commission-management" }),
      },
      {
        id: "schedule-monitoring",
        label: "Schedules",
        icon: {
          active: invoicesIconActive,
          inactive: invoicesIcon,
        },
        link: "/schedule-monitoring",
        onclick: () => handleItemClick({ id: "schedule-monitoring", link: "/schedule-monitoring" }),
      },
      {
        id: "promo-codes",
        label: "Promo Codes",
        icon: {
          active: commissionsIconActive,
          inactive: commissionsIcon,
        },
        link: "/promo-codes",
        onclick: () => handleItemClick({ id: "promo-codes", link: "/promo-codes" }),
      },
      {
        id: "services-status",
        label: "Services Status",
        icon: {
          active: adminIconActive,
          inactive: adminIcon,
        },
        link: "/services-status",
        onclick: () => handleItemClick({ id: "services-status", link: "/services-status" }),
      },
      {
        id: "adminPartnerIntegrations",
        label: "Partner Integrations",
        icon: {
          active: adminIconActive,
          inactive: adminIcon,
        },
        link: "/admin/partner-integrations",
        onclick: () =>
          handleItemClick({
            id: "adminPartnerIntegrations",
            link: "/admin/partner-integrations",
          }),
      },
    ];
  };

  const getRoleBasedSubItems = () => {
    switch (role) {
      case DASHBOARD_USER_ROLES.ADMIN:
        return [
          {
            id: "adminNational",
            label: "Nationals",
            icon: {
              active: nationalIconActive,
              inactive: nationalIcon,
            },
            link: "/admin/national",
          },
          {
            id: "adminGa",
            label: "GA",
            icon: {
              active: gaIconActive,
              inactive: gaIcon,
            },
            link: "/admin/ga",
          },
          {
            id: "adminBrokers",
            label: "Brokers",
            icon: {
              active: brokerIconActive,
              inactive: brokerIcon,
            },
            link: "/admin/brokers",
          },
          {
            id: "adminEmployerGroup",
            label: "Employer Groups",
            icon: {
              active: employerGroupIconActive,
              inactive: employerGroupIcon,
            },
            link: "/admin/employers",
          },
          {
            id: "adminEmployees",
            label: "Employees",
            icon: {
              active: employeesIconActive,
              inactive: employeesIcon,
            },
            link: "/admin/employees",
          },
        ];
      case DASHBOARD_USER_ROLES.NATIONAL:
        return [
          {
            id: "nationalGa",
            label: "GA",
            icon: {
              active: gaIconActive,
              inactive: gaIcon,
            },
            link: "/national/ga",
          },
          {
            id: "nationalBrokers",
            label: "Brokers",
            icon: {
              active: brokerIconActive,
              inactive: brokerIcon,
            },
            link: "/national/brokers",
          },
          {
            id: "nationalEmployerGroup",
            label: "Employer Groups",
            icon: {
              active: employerGroupIconActive,
              inactive: employerGroupIcon,
            },
            link: "/national/employers",
          },
          {
            id: "nationalEmployees",
            label: "Employees",
            icon: {
              active: employeesIconActive,
              inactive: employeesIcon,
            },
            link: "/national/employees",
          },
        ];
      case DASHBOARD_USER_ROLES.GA:
        return [
          {
            id: "gaBroker",
            label: "Brokers",
            icon: {
              active: brokerIconActive,
              inactive: brokerIcon,
            },
            link: "/ga/brokers",
          },
          {
            id: "gaEmployerGroup",
            label: "Employer Groups",
            icon: {
              active: employerGroupIconActive,
              inactive: employerGroupIcon,
            },
            link: "/ga/employers",
          },
          {
            id: "gaEmployees",
            label: "Employees",
            icon: {
              active: employeesIconActive,
              inactive: employeesIcon,
            },
            link: "/ga/employees",
          },
        ];
      case DASHBOARD_USER_ROLES.BROKER:
        return [
          {
            id: "brokerEmployerGroup",
            label: "Employer Groups",
            icon: {
              active: employerGroupIconActive,
              inactive: employerGroupIcon,
            },
            link: "/broker/employers",
          },
          {
            id: "brokerEmployees",
            label: "Employees",
            icon: {
              active: employeesIconActive,
              inactive: employeesIcon,
            },
            link: "/broker/employees",
          },
        ];
      default:
        return [];
    }
  };

  const adminItem = {
    id: "admin",
    label: "Admin",
    icon: {
      active: adminIcon,
      inactive: adminIcon,
    },
    // link: "/#",
    click: function (e) {
      e.preventDefault();
      setIsGroupsAdmin(!isGroupsAdmin);
      // setIscurrentState("admin");
    },
    stateVariables: isGroupsAdmin,
    subItems: getSubItemsAdmin(),
  };

  let menuItems = [
    {
      label: `${role === DASHBOARD_USER_ROLES.GA ? "GA" : role} Profile`,
      isHeader: true,
    },

    {
      id: "profile",
      label: "Profile",
      icon: {
        active: profileIconActive,
        inactive: profileIcon,
      },
      link: "/profile",
      click: () => handleItemClick({ id: "profile", link: "/profile" }),
      path: "/profile",
    },

    ...(role === DASHBOARD_USER_ROLES.ADMIN ? [adminItem] : []),
  ];

  const individualsItem = {
    id: "individuals",
    label: "Individuals",
    icon: {
      active: individualIconActive,
      inactive: individualIcon,
    },
    link: "/individuals",
    path: "/individuals",
    click: () => handleItemClick({ id: "individuals", link: "/individuals" }),
  };

  if (
    role === DASHBOARD_USER_ROLES.BROKER ||
    role === DASHBOARD_USER_ROLES.GA ||
    role === DASHBOARD_USER_ROLES.NATIONAL ||
    role === DASHBOARD_USER_ROLES.ADMIN
  ) {
    menuItems.push({
      id: "groups",
      label: "Groups",
      icon: {
        active: groupIcon,
        inactive: groupIcon,
      },
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsGroups(!isGroups);
        setIscurrentState("groups");
        // updateIconSidebar(e);
      },
      stateVariables: isGroups,
      subItems: getRoleBasedSubItems(),
    });
  } else {
    menuItems.push({
      id: "employees",
      label: "Employees",
      icon: {
        active: employeesIconActive,
        inactive: employeesIcon,
      },
      link: "/employees",
      click: () => handleItemClick({ id: "employees", link: "/employees" }),
    });
  }

  if (role !== DASHBOARD_USER_ROLES.EMPLOYER) {
    menuItems.push(individualsItem);
  }

  if (role === DASHBOARD_USER_ROLES.ADMIN) {
    menuItems.push({
      id: "commissions",
      label: "Pay Commissions",
      icon: {
        active: commissionsIconActive,
        inactive: commissionsIcon,
      },
      link: "/commissions",
      click: () => handleItemClick({ id: "commissions", link: "/commissions" }),
    });
  }
  if (
    role === DASHBOARD_USER_ROLES.BROKER ||
    role === DASHBOARD_USER_ROLES.GA ||
    (role === DASHBOARD_USER_ROLES.NATIONAL)
  ) {
    // Only show if current user does not have inherited payment info
    const showCommissions = !currentUser.inheritPaymentInfo;


    if (showCommissions) {
      menuItems.push({
        id: "commissions",
        label: "Commissions",
        icon: {
          active: commissionsIconActive,
          inactive: commissionsIcon,
        },
        link: "/commissions",
        click: () => handleItemClick({ id: "commissions", link: "/commissions" }),
      });
    }

  } else if (role !== DASHBOARD_USER_ROLES.NATIONAL) {
    menuItems.push({
      id: "billing",
      label: `${currentUser.role === DASHBOARD_USER_ROLES.ADMIN ? "Invoices" : "Billing"
        }`,
      icon: {
        active: invoicesIconActive,
        inactive: invoicesIcon,
      },
      link: "/billing",
      click: () => handleItemClick({ id: "billing", link: "/billing" }),
    });

    // Add Reports for Employer Groups only
    if (role === DASHBOARD_USER_ROLES.EMPLOYER) {
      menuItems.push({
        id: "reports",
        label: "Reports",
        icon: {
          active: invoicesIconActive,
          inactive: invoicesIcon,
        },
        link: "/reports",
        click: () => handleItemClick({ id: "reports", link: "/reports" }),
      });
    }
  }

  // Drug Search - available for all roles
  menuItems.push({
    id: "drug-search",
    label: "Drug Search",
    icon: {
      active: invoicesIconActive,
      inactive: invoicesIcon,
    },
    link: "/drug-search",
    click: () => handleItemClick({ id: "drug-search", link: "/drug-search" }),
  });

  // Resources - available for all roles (hidden for whitelabel)
  if (!isWhitelabel) {
    menuItems.push({
      id: "resources",
      label: "Resources",
      icon: {
        active: invoicesIconActive,
        inactive: invoicesIcon,
      },
      link: "/resources",
      click: () => handleItemClick({ id: "resources", link: "/resources" }),
    });
  }

  return <React.Fragment>{menuItems}</React.Fragment>;
};
export default Navdata;
